"use strict";
// Copyright (c) StrangeBee 2024
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class ElasticBuilder {
    // eslint-disable-next-line
    constructor() {
        this.tagAutoComplete = (name, freeTag, limit) => (body) => [...body, { _name: name, freeTag, limit }];
        this.name = (name) => (body) => [...body, { _name: name }];
        this.nameId = (name, idOrName, id) => (body) => [...body, { _name: name, [!id ? 'idOrName' : 'id']: idOrName }];
        this.nameCaseFilter = (name, filters) => (body) => [...body, { _name: name, caseFilter: filters }];
        this.nameAlertFilter = (name, filters) => (body) => [...body, { _name: name, alertFilter: filters }];
        this.page = (paginationProps, extraData, options = {}) => (body) => {
            if (paginationProps) {
                const { page, itemsPerPage } = paginationProps;
                return [
                    ...body,
                    Object.assign({ _name: 'page', from: page * itemsPerPage, to: (page + 1) * itemsPerPage, extraData }, options),
                ];
            }
            return body;
        };
        this.count = () => (body) => [...body, { _name: 'count' }];
        this.sort = (sortOptions) => (body) => {
            if (sortOptions) {
                return [...body, { _name: 'sort', _fields: sortOptions.map(utils_1.convertSortOptions) }];
            }
            return body;
        };
        this.filter = (filters) => (body) => {
            if (filters === null || filters === void 0 ? void 0 : filters.length) {
                return [...body, Object.assign({ _name: 'filter' }, (0, utils_1.convertToSearchQuery)(filters, true))];
            }
            return body;
        };
        this.aggregation = (config) => (body) => {
            if (!config) {
                return body;
            }
            const { agg, field, select, order, size, fields, interval } = config;
            const orderOpt = order ? { _order: order } : {};
            const sizeOpt = size ? { _size: size } : {};
            return [
                ...body,
                Object.assign(Object.assign({ _name: 'aggregation', _agg: agg, _field: field, _select: select, _fields: fields, _interval: interval }, orderOpt), sizeOpt),
            ];
        };
        this.compose = (...composers) => (body) => composers.reduce((acc, composer) => (composer ? composer(acc) : acc), body);
        this.buildBody = ({ head, filters, aggregation, paginationOptions, sort, extraData, options, count, originalHead, }) => this.compose(head.find(({ _name }) => _name === 'similarCases' || _name === 'similarAlerts' || _name === 'similarCaseCount')
            ? undefined
            : this.filter(filters), originalHead.find((queryParam) => 'name' in queryParam && queryParam.name === 'inCase')
            ? this.name('inCase')
            : undefined, this.aggregation(aggregation), this.sort(sort), this.page(paginationOptions, extraData, options), count && this.count())(head);
        this.buildHead = (body, head, filters) => this.compose(...head.map((queryParam) => 'idOrName' in queryParam
            ? this.nameId(queryParam.name, queryParam.idOrName, queryParam.id)
            : 'caseFilter' in queryParam
                ? this.nameCaseFilter(queryParam.name, (0, utils_1.convertToSearchQuery)(filters, true))
                : 'alertFilter' in queryParam
                    ? this.nameAlertFilter(queryParam.name, (0, utils_1.convertToSearchQuery)(filters, true))
                    : 'filter' in queryParam
                        ? this.filter([queryParam.filter])
                        : queryParam.name === 'tagAutoComplete'
                            ? this.tagAutoComplete(queryParam.name, queryParam.freeTag, queryParam.limit)
                            : queryParam.name === 'inCase'
                                ? undefined
                                : this.name(queryParam.name)))(body);
        this.prepare = (_a) => {
            var { selector: { head, extraData, initialFilters = [], options = {} }, sort, filters = [] } = _a, props = __rest(_a, ["selector", "sort", "filters"]);
            return {
                query: this.buildBody(Object.assign({ head: this.buildHead([], head, filters), extraData,
                    options,
                    sort, filters: [...initialFilters, ...filters], originalHead: head }, props)),
            };
        };
    }
    static getInstance() {
        if (!ElasticBuilder.instance) {
            ElasticBuilder.instance = new ElasticBuilder();
        }
        return ElasticBuilder.instance;
    }
}
exports.default = ElasticBuilder;
